import { render, staticRenderFns } from "./AdminProductSelectorsNewScreen.vue?vue&type=template&id=a6a3c09c&scoped=true&"
import script from "./AdminProductSelectorsNewScreen.vue?vue&type=script&lang=js&"
export * from "./AdminProductSelectorsNewScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a3c09c",
  null
  
)

export default component.exports